/* This is the js file for the Collapse feature on PDP, pages and blog posts
   It checks for the height of sections and textContent
   At the same time, 2 buttons are rendered and a 'click' event listener is attached to each button  */

document.addEventListener("DOMContentLoaded", function (event) {
  const collapsibleContainers = document.querySelectorAll(
    ".shopify-section:not(.shopify-section .shopify-section, .shopify-section.site-header-wrapper,#shopify-section-static-footer,.shopify-section.accordion--section)"
  );
  collapsibleContainers.forEach((element) => {
    if (
      element.textContent.split(/\s+/).length >= 300 &&
      element.getBoundingClientRect().height >= 900
    ) {
      element.classList.add("heightAdjust");
      const div = document.createElement("div");
      div.classList.add("collapsible-button-wrapper");
      const button = document.createElement("button");
      button.textContent = "Show More";
      button.classList.add("showMore");
      div.appendChild(button);
      element.insertAdjacentElement("afterend", div);

      const hiddenDiv = document.createElement("div");
      hiddenDiv.classList.add("collapsible-hidden-button-wrapper");
      const lessButton = document.createElement("button");
      lessButton.textContent = "Show Less";
      lessButton.classList.add("showLess");
      hiddenDiv.appendChild(lessButton);
      lessButton.parentElement.style.display = "none";
      element.insertAdjacentElement("afterend", hiddenDiv);

      button.addEventListener("click", () => {
        element.classList.remove("heightAdjust");
        button.parentElement.style.display = "none";
        lessButton.parentElement.style.display = "";
      });

      lessButton.addEventListener("click", () => {
        element.classList.add("heightAdjust");
        const nextElement = element.nextElementSibling;

        if (nextElement) {
          nextElement.scrollIntoView({ behavior: "smooth" });
        } else {
          element.scrollIntoView({ behavior: "smooth" });
        }
        button.parentElement.style.display = "";
        lessButton.parentElement.style.display = "none";
      });
    }
  });
});
